module.exports = __webpack_public_path__ + "components/country-flag/static/tf-4601a229f910821cf3d7101625f80340.svg";